import { motion } from "framer-motion";
import { STATS } from "@/lib/content";

const fade = {
  initial: { opacity: 0, y: 18 },
  whileInView: { opacity: 1, y: 0 },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
  viewport: { once: true, margin: "-100px" },
};

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative border-t border-hairline">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-28 lg:py-40">
        <div className="heraldic-rule mb-20"><span className="mark">✦</span></div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24">
          <motion.div {...fade} className="lg:col-span-5">
            <span className="overline" data-testid="about-overline">About — KP</span>
            <h2 className="font-serif text-4xl md:text-6xl font-medium leading-[0.95] tracking-tight mt-6">
              I do not teach you to trade.
              <br />
              <span className="italic font-light text-platinum">I rebuild the trader.</span>
            </h2>
          </motion.div>

          <motion.div {...fade} className="lg:col-span-6 lg:col-start-7">
            <div className="space-y-6 text-sand font-sans text-base md:text-lg leading-relaxed">
              <p>
                Somewhere along the way it became impossible to ignore: the difference
                between the traders who eventually compound and those who quietly disappear
                is almost never the strategy. It is the operator running it.
              </p>
              <p>
                KP Capital — Private Trading Society — is the deliberate narrowing of my
                practice. No signals. No courses. No public group. A small number of
                serious traders, taken personally, for the only work that ever mattered:
                <span className="text-bone"> the work behind the screen.</span>
              </p>
            </div>
          </motion.div>
        </div>

        {/* Stats */}
        <div className="mt-28 grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-20 border-t border-hairline pt-20">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 }}
              viewport={{ once: true, margin: "-80px" }}
              data-testid={`stat-${i}`}
            >
              <div className="editorial-num text-7xl md:text-8xl">{s.value}</div>
              <div className="mt-6 overline">{s.label}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
